function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 19C4.5 19 0 14.75 0 9.5S4.5 0 10 0s10 4.25 10 9.5S15.5 19 10 19zm0-2c4.42 0 8-3.38 8-7.5S14.42 2 10 2 2 5.38 2 9.5 5.58 17 10 17zm24 2c-5.5 0-10-4.25-10-9.5S28.5 0 34 0s10 4.25 10 9.5S39.5 19 34 19zm0-2c4.42 0 8-3.38 8-7.5S38.42 2 34 2s-8 3.38-8 7.5 3.58 7.5 8 7.5z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11.5h8v-2h-8zm7.55-3.6l.9-1.8L22 3.89l-4.46 2.23.9 1.78L22 6.12z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 6V2h-2v4z"
});
function SvgGlasses(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 19",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default ForwardRef;